import api from '../../api'
import * as types from '../mutation-types'
import Axios from 'axios';

// initial state
const state = {
  error: null,
  notice: null,
  loading: true,
  loading_progress: 0,
  videoId: null,
  social: {
    facebook: "https://www.facebook.com/Senepoldabarra/",
    instagram: "https://www.instagram.com/senepoldabarra/",
    youtube: "https://www.youtube.com/channel/UC4hSBOqUWzNMzcq7XIZ193w"
  }
};

// getters
const getters = {
  isLoading: state => state.loading_progress < 100,
  loadingProgress: state=> state.loading_progress,
  loadingIncrement: state => { return 100 / window.SETTINGS.LOADING_SEGMENTS }
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.INCREMENT_LOADING_PROGRESS] (state, val) {
    state.loading_progress = Math.min(state.loading_progress + getters.loadingIncrement(), 100)
  },

  setVideoId(state, data){
    state.videoId = data
  },

  [types.RESET_LOADING_PROGRESS] (state) {
    state.loading_progress = 0
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hub.js